import { ReactNode, useEffect, useState } from 'react';
interface SecureLayoutProps {
  children: ReactNode;
  maxWidth?: number;
  className?: string;
}
export default function AnimationLayout({
  children,
  maxWidth = 400,
  className = '',
}: SecureLayoutProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 50);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={className}
      style={{
        minHeight: '90vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        padding: 20,
      }}
    >
      {/* Brand glows */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage:
            'radial-gradient(circle at 15% 20%, rgb(var(--gold) / 0.14) 0%, transparent 40%), radial-gradient(circle at 85% 80%, rgb(26 61 166 / 0.14) 0%, transparent 45%)',
        }}
      />

      {/* Page Content */}
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth,
          opacity: mounted ? 1 : 0,
          transform: mounted ? 'translateY(0)' : 'translateY(18px)',
          transition: 'all .6s ease',
        }}
      >
        {children}
      </div>
    </div>
  );
}
